import { render, staticRenderFns } from "./AccountNftTransferTable.vue?vue&type=template&id=6957b39e&scoped=true"
import script from "./AccountNftTransferTable.vue?vue&type=script&lang=js"
export * from "./AccountNftTransferTable.vue?vue&type=script&lang=js"
import style0 from "./AccountNftTransferTable.vue?vue&type=style&index=0&id=6957b39e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6957b39e",
  null
  
)

export default component.exports